import React from "react";
import { Table, Button } from "reactstrap";
import { MINIJUEGOS, HISTORIAS, PLANETAS, NIVELES, CINTURONES } from "./consts_act";

export default class TablaInstituciones extends React.Component {
  render() {
    console.warn("LIST RECIVED",this.props.data)
    if (!this.props.data) return null;
    console.warn(this.props.data)
    return (
      <Table hover className="mb-0">
        <thead>
        <tr>
     
     <th className="text-center">Intitución</th>
     <th className="text-center">Localidad</th>
     <th className="text-center">Provincia</th>


   </tr>
 </thead>
 <tbody>
   {this.props.data.map((e, index) => {
     return (
       <tr key={e.id}>
         
         <td className="text-center">{e.nombre}</td>
         <td className="text-center">{e.localidad.nombre}</td>
         <td className="text-center">{e.localidad.provincia.nombre}</td>

       </tr>
            );
          })}
          <div>
            <nav
              aria-label="Page"
              className="d-flex w-100 justify-content-center  "
            >
              <ul className="pagination">
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(0)}
                >
                  <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span className="sr-only"> Pagina Anterior</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link">{this.props.page}</a>
                </li>
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(1)}
                >
                  <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span className="sr-only">Proxima Pagina</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Pais/component/InstitucionesList.js